import { render, staticRenderFns } from "./OrderStateForm.vue?vue&type=template&id=0b83a450&scoped=true"
import script from "./OrderStateForm.vue?vue&type=script&lang=js"
export * from "./OrderStateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83a450",
  null
  
)

export default component.exports